import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

export const fetchSmartAggregates = (data_params) => {
    return apiAgent({
        method: "get",
        url: "/aggregates/smart_articles",
        params: data_params
    })
}
export const fetchAggregates = (data_params, type) => {
    let aggregate_url = "get_feed_aggregates"
    if(type === 'high')
        aggregate_url = "get_feed_aggregates"
    if(type === 'mid' || type === 'low' || type === 'smartpublish')
        aggregate_url = 'get_article_aggregates'
    if(type === 'prospects')
        aggregate_url = "get_prospect_aggregates"
    if(type === 'directory')
        aggregate_url = "get_directory_aggregates"
    return apiAgent({
        method: "get",
        url: getApiUrl(aggregate_url),
        params: data_params
    })
}

export const teamUpdate = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl("team_update"),
        params: data_params
    })
}

export const getTeamInfo = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl("get_team_info"),
        params: data_params
    })
}

export const getPublishingGuidelines = () => {
    return apiAgent({
        method: "get",
        url: "/team_members/publishing_guidelines",
    })
}

export const updatePublishingGuidelines = (data_params) => {
    return apiAgent({
        method: "post",
        url: "/team/publishing_guidelines",
        params: data_params
    })
}

export const acknowledgeGuidelines = () => {
    return apiAgent({
        method: "post",
        url: "/team_members/publishing_guidelines/acknowledge",
    })
}

export const discardArticles = (data_params) => {
    return apiAgent({
        method: "post",
        url: "/aggregates/multiple_discard",
        params: { team_id: data_params.team_id },
        data: data_params
    })
}

export const deleteArticles = (data_params) => {
    return apiAgent({
        method: "post",
        url: "/aggregates/multiple_delete",
        params: { team_id: data_params.team_id },
        data: data_params
    })
}

export const triggerNotificationMail = (data_params) => {
    return apiAgent({
        method: "post",
        url: "/team/news_notifications_mail",
        params: { team_id: data_params.team_id },
        data: data_params
    })
}

export const sendNewsResults = (data_params) => {
    return apiAgent({
        method: "post",
        url: "/team/send_news_results",
        params: { team_id: data_params.team_id },
        data: data_params
    })
}
